'use client'

import { useState } from 'react'
import ReactMarkdown from 'react-markdown'

import { Accordion } from '@graftcode/design-system'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'

import { slugify } from '@/shared/components/ContentNav/utils/slugify'
import { MARKDOWN_RENDERER_TEST_IDS } from '@/shared/docs-test-ids.const'

import type { MarkdownComponents } from '../../MarkdownRenderer.types'

import styles from '../../MarkdownRenderer.module.scss'

type CollapsibleProps = {
  title?: string
  content: string
  markdownComponents: MarkdownComponents
  contentId: string
}

export function Collapsible({ title, content, markdownComponents, contentId }: CollapsibleProps) {
  const [isOpen, setIsOpen] = useState(false)
  const navId = title ? slugify(title) : undefined

  return (
    <div id={navId} className={styles.collapsibleWrapper} data-testid={MARKDOWN_RENDERER_TEST_IDS.collapsible}>
      <Accordion
        id={contentId}
        title={title || 'Click to expand'}
        variant="default"
        isOpen={isOpen}
        content={
          <div className={styles.accordionContent}>
            <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={markdownComponents}>
              {content}
            </ReactMarkdown>
          </div>
        }
        onCollapseChange={setIsOpen}
      />
    </div>
  )
}
